<template>
	<div class="apps-grid">
		<div v-if="availableApps.length" class="apps">
			<AppButton
					v-for="app in sortedAvailableApps"
					:key="app.key"
					:app="app"
					:disabled="disabled"
					:is-active="app.name === activeAppName"
					@click="$emit('launch', app)"
			/>
		</div>
		<div v-else class="no-apps-message">
			<p>No apps available</p>
		</div>
		
		<template v-if="alternateApps.length">
			<Divider/>
			<p class="divider-label">MORE APPS</p>
			<Divider/>
			<div class="apps">
				<AppButton
						v-for="app in sortedAlternateApps"
						:key="app.name"
						:app="app"
						:disabled="disabled"
						:is-active="app.name === activeAppName"
						@click="$emit('launch', app)"
				/>
			</div>
		</template>
	</div>
</template>

<script setup>
import {computed} from 'vue'
import AppButton from './AppButton.vue'
import Divider from './Divider.vue'

const props = defineProps({
	availableApps: {type: Array, default: () => []},
	alternateApps: {type: Array, default: () => []},
	disabled: {type: Boolean, default: false},
	activeAppName: {type: String, default: null},
})

const sortedAvailableApps = computed(() => {
	return [...props.availableApps].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
})

const sortedAlternateApps = computed(() => {
	return [...props.alternateApps].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
})

defineEmits(['launch'])
</script>

<style scoped>
.apps-grid {
	margin-bottom: var(--spacing-xl);
}

.apps {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: var(--spacing-md);
}

.no-apps-message {
	text-align: center;
	padding: var(--spacing-3xl) 0;
	color: var(--color-text-secondary);
	font-style: italic;
}

.divider-label {
	font-size: var(--font-size-xs);
	letter-spacing: var(--spacing-xs);
	margin-bottom: var(--spacing-md);
}
</style>